module.exports = __webpack_public_path__ + "img/trash.cb709d2a.svg";